

import { isObservable } from '../methods/soby'
import { useGuarded } from '../hooks/use_guarded'
import { useUntracked } from '../hooks/soby'
import { ternary } from '../soby'
import { isComponent, isFunction, isTruthy } from '../utils/lang'
import type { Child, FunctionMaybe, ObservableReadonly, Truthy } from '../types'


//TODO: Support an is/guard prop, maybe

export const If = <T>({ when, fallback, children }: { when: FunctionMaybe<T>, fallback?: Child, children: Child | ((value: (() => Truthy<T>)) => Child) }): ObservableReadonly<Child> => {

  if (isFunction(children) && !isObservable(children as any) && !isComponent(children)) { // Calling the children function with an (() => Truthy<T>)

    const truthy = useGuarded(when, isTruthy)

    return ternary(when, useUntracked(() => (children as Function)(truthy)), fallback)

  } else { // Just passing the children along

    return ternary(when, children as Child, fallback) //TSC

  }

}
